import { EDITOR_ID } from '@/components/Editor/contants'
import { useRef, useState } from 'react'
import { debounce } from 'lodash'

const config = {
  attributes: true,
  childList: true,
  subtree: true,
  // 需开启,否则输入的纯英文字符不会触发监听
  characterData: true
}

const INTERVAL_TIME = 2000
let observer: MutationObserver | null = null

const useDomCheck = () => {
  // 是否初始化文本,dom没有渲染完毕是不允许监听的
  const [initStatus, setInitStatus] = useState<boolean>(false)
  const [changeStatus, setChangeStatus] = useState<boolean>(false)
  const changeStatusRef = useRef<boolean>(changeStatus)
  // 记录上一次的slate数据层的值
  const lastSlateValue = useRef<any>('')
  // 当前编辑器editor的引用
  const editorRef = useRef<any>(null)
  

  if (!observer) {
    observer = new MutationObserver(debounce((mutationList) => {    
      // 仅对比Slate数据层变更,(UI层面的变更不应该触发自动保存)
      const currentSlateValue = JSON.stringify(editorRef.current?.children)
      if (currentSlateValue === lastSlateValue.current) {
        return
      }
      lastSlateValue.current = currentSlateValue

      if (changeStatusRef.current) {
        return
      }
      handleChangeStatus(true)
    }, INTERVAL_TIME))
  }

  const startObDom = () => {
    // 仅监听编辑器本体区域
    const editorAreaEle = document.getElementById(EDITOR_ID)
    if (!editorAreaEle || changeStatusRef.current) {
      return
    }
    observer?.observe(editorAreaEle, config)
    console.log('开启监听dom')
  }

  const stopObDom = () => {
    observer?.disconnect()
    changeStatusRef.current = false
    setChangeStatus(false)
    console.log('关闭监听dom')
  }

  const handleChangeStatus = (status: boolean) => {
    setChangeStatus(status)
    changeStatusRef.current = status
  }

  const handleInitStatus = (status: boolean) => {
    if (status) {
      // Treat the loaded editor state as the baseline, so hydration is not saved as a user edit.
      lastSlateValue.current = JSON.stringify(editorRef.current?.children)
      changeStatusRef.current = false
      setChangeStatus(false)
    }
    setInitStatus(status)
  }

  // 更新当前正文编辑器的ref引用
  const updateEditorRef = (value: any) => {
    editorRef.current = value
  }

  return {
    changeStatus,
    initStatus,
    startObDom,
    stopObDom,
    handleChangeStatus,
    handleInitStatus,
    updateEditorRef
  }
}

export default useDomCheck
